export default __webpack_public_path__ + "static/media/1208.68721d10.png";